import { animate, keyframes, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { IProduct } from 'situview-webapi-client';
import * as kf from '../../core/keyframes';

@Component({
  selector: 'product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.less'],
  animations: [ 
    trigger('cardAnimator', [
      transition('* => wobble', animate(1000, keyframes(kf.wobble))),
      transition('* => swing', animate(1000, keyframes(kf.swing))),
      transition('* => jello', animate(1000, keyframes(kf.jello))),
      transition('* => zoomOutRight', animate(1000, keyframes(kf.zoomOutRight))),
      transition('* => slideOutLeft', animate(1000, keyframes(kf.slideOutLeft))),
      transition('* => rotateOutUpRight', animate(1000, keyframes(kf.rotateOutUpRight))),
      transition('* => flipOutY', animate(1000, keyframes(kf.flipOutY))),
      transition('* => headShake', animate(1000, keyframes(kf.headShake)))
    ])
  ]
})
export class ProductCardComponent implements OnInit, OnChanges {

  @Input() item: IProduct | undefined;
  @Input() readonly: boolean = true;
  @Input() searchValue: string = "";
  @Input() selected: boolean = false;
  @Input() animationState: string = '';

  constructor() { }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.animationState) {
      this.startAnimation(changes.animationState.currentValue);
    }
  }

  startAnimation(state: string) {
    if (!this.animationState) {
      this.animationState = state;
    }
  }

  resetAnimationState() {
    this.animationState = '';
  }
}
